import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '../../../create-mock-endpoint';

import { WalletUserGiftBalanceDetailResponse } from '@/repositories/generated';

const response: WalletUserGiftBalanceDetailResponse = {
  prepaidValueTotal: 45000,
  prepaidValueExpiresAt: [
    { balance: 30000, expiresAt: '2026-06-30T23:59:59+09:00' },
    { balance: 15000, expiresAt: '2026-09-30T23:59:59+09:00' },
  ],
  bonusValueTotal: 5000,
  bonusValueExpiresAt: [
    { balance: 5000, expiresAt: '2026-06-30T23:59:59+09:00' },
  ],
  lastUpdatedAt: '2026-04-23T00:00:00+09:00',
};

export const walletUserGiftBalanceDetail = http.get(
  createMockEndpoint('/wallet_user/gift_balance_detail/:walletUserId/:paymentMethodId/:walletServiceId'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
